<!--
Deadline component
Usage: <Deadline title="text" body="text" icon="fa-name" link="url" />
@author ab557z
-->
<template>
  <div class="dlDiv" >
    <table width="100%">
    <tr>
        <td :class="'dlDateSubHeader' + (overdue ? '-overdue' : '')" colspan='4'>{{ displayDueDate }}</td>
    </tr>
    <tr>
        <td class="dlMCSubHeader" colspan='4'><div style="display:flex;align-items:center;"><img class="mcImg"  src="@/assets/index/hp_moodle.svg" /><span style="padding-left:12px;">{{ deadline.moodlecourse }}</span></div></td>
    </tr>
    <tr>
      <td class='dlSpace' colspan='4'></td>
    </tr>
    <tr class="dlBody">
      <td class="dlLeftSide">
      <p class="dlDate">
      {{ processDueTime (deadline.duedate) }}
      <!-- {{ formatDateTime (deadline.duedate) }}  -->
      </p>
      </td>
      <td class="dlDetails">
        <table class="dlCourseName">
          <tr>
            <td class="dlHeader" >
              <ExpandText
                :content="isSubAssessment ? deadline.assessmentname : deadline.coursename"
                :limit=30
                :allowExtra=10 />
            </td>
          </tr>
        </table>

        <div v-if="!isSubAssessment" class="dlName">{{ deadline.assessmentname }}</div>
        <div class="dlType">{{ deadline.assessmenttype }}</div>

      <!--<img src="@/assets/deadlineIcon.png" class="deadlineImg" /> -->
    </td>
    <td class="dlSaArrow">
      <span v-if="isIndividualComponents (deadline)">
          <p />
          <div class="subAssessment" @click=openAssessment(deadline.id)>
            <font-awesome-icon icon="arrow-right" size="sm" class="cwItemChev"></font-awesome-icon>
          </div>
      </span>
    </td>
    </tr>
    <tr>
      <td class='dlSpace' colspan='4'></td>
    </tr>
    <tr>
      <td colspan='4' class="dlFooter">
                <!-- <p>feedback: {{ deadline.feedback }}</p> -->
                <!-- they want submitted assignments to appear in the Grades tab so ... -->
        <!-- span class="dlStatusInd" v-if="isSubmitted (deadline)">
            <img src="@/assets/af/s_submit.svg">
            <p class="dlStatus s_submitted">Submitted</p>
        </span -->
        <span class="dlStatusInd">
          <img v-if="deadline.status == 'submit'" src="@/assets/af/s_submit.svg" title="submit" alt="submit">
          <img v-else-if="deadline.status == 'not submitted'" src="@/assets/af/s_notsubmitted.svg" title="not submitted" alt="not submitted">
          <img v-else-if="deadline.status == 'submission not open'" src="@/assets/af/s_notopen.svg" title="submission not open" alt="submission not open">
          <img v-else-if="deadline.status == 'overdue'" src="@/assets/af/s_overdue.svg" title="overdue" alt="overdue">
          <p :class="'dlStatus s_' + shortStatus(deadline.status)">{{ processStatus(deadline.status )}}</p>
        </span>

        <span>&nbsp;<p class="moodleAFLink"><a target="_blank" rel="noreferrer noopener" class="seeMoodle" :href="deadline.assessmenturl">
            See assessment on Moodle &nbsp;<font-awesome-icon icon="fa-external-link"></font-awesome-icon>
          </a></p><br></span>

      </td>
    </tr>
            <tr v-if="isIndividualComponents (deadline)">
            <td colspan='4' style='padding-left:20px'>
                            <span>
                  <p class="dlStatus red">SEE INDIVIDUAL COMPONENTS</p>
                </span>
</td>
</tr>
  </table>
  </div>
</template>

<script>
// import momentPlugin from '@fullcalendar/moment'
// import moment from '@fullcalendar/moment'
import StringUtil from '@/mixins/StringUtil.js'
import AssFeedCommon from '@/mixins/AssFeedCommon.js'
import ExpandText from '@/components/ExpandableText.vue'
// import submittedIcon from '@/assets/af_submitted.svg'
// import overdueIcon from '@/assets/af_overdue.svg'

export default {
  name: 'Deadline',
  components: {
    ExpandText
  },
  // props: ['title'],
  props: ['deadline', 'isSubAssessment', 'pos'],
  data () {
    let isOverdue = false
    let dueDate = this.friendlyDueDate(this.deadline)
    if (dueDate.startsWith('Overdue')) {
      isOverdue = true
    }
    return {
      displayDueDate: dueDate,
      overdue: isOverdue,
      inwidth: window.innerWidth
      // calendarPlugins: [ momentPlugin ]
    }
  },
  mixins: [StringUtil, AssFeedCommon],
  // el: '.dlDates',

  mounted () {
    const bgHalfWidth = 28 // 36px wide with 10px margins
    const bgHalfHeight = 28 // 36 px tall with 10px margins

    // var img = document.getElementById('notifIcon' + this.$vnode.key)
    var img = document.getElementById('notifIcon' + this.pos)

    if (typeof img !== 'undefined' && img != null) {
      const imgWidth = img.getBoundingClientRect().width
      const imgHeight = img.getBoundingClientRect().height

      var marginLeft = bgHalfWidth - (imgWidth / 2)
      var marginTop = bgHalfHeight - (imgHeight / 2)

      img.style.left = marginLeft
      img.style.top = marginTop
    } else { console.log('image is null') }
  },
  methods: {
    processStatus (status) {
      // at one point we were going to display 'open for submission' for status 'submit'
      // because we can't submit assignments within the app but WCSC-1910 says to use 'submit', so ...
      if (typeof status === 'string') {
        let ret = status
        if (typeof ret === 'string') {
          ret = ret.substring(0, 1).toUpperCase() + ret.substring(1)
        }
        return ret
      }
    },
    shortStatus (status) {
      if (typeof status === 'string') {
        switch (status) {
          /* any special cases go here, otherwise, */
          case 'submission not open':
            return 'notopen'
          default:
            return status.replace(' ', '')
        }
      }
      return 'X'
    },
    formatDateOldNotUsed (milliseconds) {
      // alert (milliseconds)
      var date = new Date()
      date.setTime(milliseconds)
      // return date.toDateString()
      // var dateString = date.getDate() + ' ' + date.getFullYear()
      var options = { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: 'numeric' }
      var dateString = date.toLocaleDateString('en-GB', options)
      return dateString
    } /*
    isGraded (status) {
      console.log(status)
      if (status.toUpperCase() === 'GRADED') {
        console.log('status = graded, return true')
        return true
      }
      return false
    }, */
    // isOverdue (status) {
  }
}
</script>
<style lang="scss" scoped>
@import '@/scss/common-styles.scss';

</style>
